
import EditInput from '@/components/edit/EditInput';

export default {
    extends: EditInput,

    computed: {
        options() {
            return $.getSelectOptions(this.collName, this.fullPath);
        },
    },
};
